module.exports = __webpack_public_path__ + "static/14-POL-NALEWKA.dc4a609d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/beverages/14-POL-NALEWKA.png
// module id = 610
// module chunks = 35783957827783